import React from 'react';
import { icons } from './SvgData';

export type IconProps = {
  name: keyof typeof icons;
  size?: number;
  color?: string | undefined;
  onClick?: () => void;
  className?: string;
} & React.SVGProps<SVGSVGElement> & {
    title?: string;
  };

const Icon: React.FC<IconProps> = ({ name, size = 24, color = '', className, ...otherProps }) => {
  const SvgIcon = icons[name];

  if (!SvgIcon) {
    console.warn(`Icon with name "${name}" not found.`);
    return null;
  }

  return <SvgIcon className={className} height={size} width={size} color={color} {...otherProps} />;
};

export default Icon;
